import * as constants from './constants'
import * as ReducerHelper from '@eig-builder/core-utils/helpers/reducer-helper'

const initialState = {
  getAccountByTypeRetrieving: false,
  getAccountByIdRetrieving: false,
  getServicesByAccountRetrieving: false,
  getOrdersByAccountRetrieving: false,
  getDomainsByAccountRetrieving: false,
  getEmailsByAccountRetrieving: false,
  getEventsByAccountRetrieving: false,
  getPayPalTransactionsRetrieving: false,
  postChangeEmailRetrieving: false,
  cancelOrderRetrieving: false,
  synchronizeCardsRetrieving: false,
  getChangeTargetsRetrieving: false,
  changeServiceRetrieving: false,
  addServiceRetrieving: false,
  getUsersForTheirRolesResponse: [],
  filterCommentsResponse: null,
  nameServersRetrieving: false,
  getDomainRenewalLogsRetrieving: false,
  getDomainRenewalLogsResponse: [],
  updateNameServersSuccess: false,
  updateNameServersError: null,
  updateNameServersPending: false,
  removeFreeDomainCreditRetrieving: false,
  getContactsBySiteRetrieving: false,
  cancelMultipleServicesRetrieving: false,
  cancelMultipleServicesSuccess: false,
  cancelServiceSuccess: false,
  cancelServiceRetrieving: false,
  getFreeDomainAvailableResponse: null,
  getRegisteredDomainsRetrieving: false,
  cancelAccountRetrieving: false,
  downgradeAccountRetrieving: false
}

const reducer = (state = initialState, action) => {
  const listenState =
    ReducerHelper.listenToFetchActions(state, action, constants.GET_ACCOUNT_BY_TYPE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_ACCOUNT_ORDER_BY_ID) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_SERVICES_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_ORDERS_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_CANCELLED_ORDERS_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_COMPLETED_ORDERS_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_PENDING_ORDERS_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_EMAILS_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_PAYPAL_TRANSACTIONS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_PAYPAL_NEW_TRANSACTIONS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_DOMAIN_MIGRATE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_DELETE_DOMAIN) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_DOMAIN_SWAP) ||
    ReducerHelper.listenToFetchActions(state, action, constants.RESTORE_SERVICE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.ENABLE_LOCAL_DEBUG) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_CHANGE_EMAIL) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_DNS_BY_ID) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_DOMAIN_BY_ID) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_DNS_BY_ID) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_DNS_BY_ID) ||
    ReducerHelper.listenToFetchActions(state, action, constants.TRANSFER_DOMAIN_BY_NAME) ||
    ReducerHelper.listenToFetchActions(state, action, constants.MODIFY_DNS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_RENEWAL_REPORT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_USERS_FOR_THEIR_ROLES) ||
    ReducerHelper.listenToFetchActions(state, action, constants.ADD_USER_ROLES) ||
    ReducerHelper.listenToFetchActions(state, action, constants.REMOVE_USER_ROLES) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_FOLLOW_UPS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_RELEASE_NOTES) ||
    ReducerHelper.listenToFetchActions(state, action, constants.DELETE_RELEASE_NOTE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_IMAGE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_AGENT_EVENTS_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_PASSWORD_RESET_EVENTS_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_LOGIN_EVENTS_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_UBERSMITH_EVENTS_BY_UBERCLIENTID) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_ALLOW_MAIL_PURCHASES) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_ALLOW_DOMAIN_PURCHASES) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_ALLOW_CHANGE_PAYMENT_METHOD) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_COMMENTS_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.PUT_UPDATE_COMMENT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_UBERSMITH_COMMENTS_BY_UBERCLIENTID) ||
    ReducerHelper.listenToFetchActions(state, action, constants.FILTER_COMMENTS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_SDN_EVENTS_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_CHANGE_TARGETS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.CHANGE_SERVICE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.ADD_SERVICE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_NAMESERVERS_BY_DOMAIN_ID) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_PARTNERS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.CREATE_NEW_ACCOUNT_TEST_TOOL) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_ACCOUNT_TEST_TOOL) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_SITES_TEST_TOOL) ||
    ReducerHelper.listenToFetchActions(state, action, constants.CREATE_NEW_SITE_TEST_TOOL) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GENERATE_TOKEN_TEST_TOOL) ||
    ReducerHelper.listenToFetchActions(state, action, constants.ADD_CREDITS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.ACCOUNT_RELINK) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_DOMAIN_RENEWAL_LOGS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_GOODWILL_CREDITS_FOR_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.REMOVE_FREE_DOMAIN_CREDIT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.CANCEL_MULTIPLE_SERVICES) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_FREE_DOMAIN_AVAILABLE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.RESET_TEST_TOOL) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_REGISTERED_DOMAINS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.CANCEL_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.RESTORE_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.DOWNGRADE_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.SUSPEND_DOMAIN) ||
    ReducerHelper.listenToFetchActions(state, action, constants.UNSUSPEND_DOMAIN) ||
    ReducerHelper.listenToFetchActions(state, action, constants.ENABLE_PRIVACY_PROTECTION) ||
    ReducerHelper.listenToFetchActions(state, action, constants.DISABLE_PRIVACY_PROTECTION) ||
    ReducerHelper.listenToFetchActions(state, action, constants.ENABLE_THEFT_PROTECTION) ||
    ReducerHelper.listenToFetchActions(state, action, constants.DISABLE_THEFT_PROTECTION) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_FREE_EMAIL_AVAILABLE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_REFUNDABLE_SERVICES) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_REFUND_SERVICES) ||
    ReducerHelper.listenToFetchActions(state, action, constants.CANCEL_SERVICE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_SINGLEPLATFORM_LOCATION) ||
    state

  switch (action.type) {
    case constants.GET_ACCOUNT_BY_ID_PENDING:
      return {
        ...state,
        getAccountByIdRetrieving: true,
        getAccountByIdError: null,
        getAccountByIdExtraArgs: action.extraArguments
      }
    case constants.GET_ACCOUNT_BY_ID_FULFILLED:
      return {
        ...state,
        getAccountByIdRetrieving: false,
        getAccountByIdError: null,
        getAccountByIdResponse: action.body,
        getAccountByIdExtraArgs: action.extraArguments
      }
    case constants.GET_ACCOUNT_BY_ID_ERROR:
      return {
        ...state,
        getAccountByIdRetrieving: false,
        getAccountByIdError: action.body || true,
        getAccountByIdResponse: null,
        getAccountByIdExtraArgs: action.extraArguments,
        getAccountByIdErrorStatus: action.response.status
      }
    case constants.POST_CHANGE_EMAIL_PENDING:
      return {
        ...state,
        postChangeEmailRetrieving: true,
        postChangeEmailError: null,
        postChangeEmailResponse: null,
        postChangeEmailExtraArgs: action.extraArguments
      }
    case constants.POST_CHANGE_EMAIL_FULFILLED:
      return {
        ...state,
        postChangeEmailRetrieving: false,
        postChangeEmailError: null,
        postChangeEmailResponse: 'OK',
        postChangeEmailExtraArgs: action.extraArguments
      }
    case constants.POST_CHANGE_EMAIL_ERROR:
      return {
        ...state,
        postChangeEmailRetrieving: false,
        postChangeEmailError: action.body || true,
        postChangeEmailResponse: null,
        postChangeEmailExtraArgs: action.extraArguments,
        postChangeEmailErrorStatus: action.response.status
      }
    case constants.CREATE_EXTERNAL_ACCOUNT_PENDING:
      return {
        ...state,
        createExternalAccountRetrieving: true,
        createExternalAccountError: null,
        createExternalAccountResponse: null,
        createExternalAccountExtraArgs: action.extraArguments
      }
    case constants.CREATE_EXTERNAL_ACCOUNT_FULFILLED:
      return {
        ...state,
        createExternalAccountRetrieving: false,
        createExternalAccountError: null,
        createExternalAccountResponse: action.body,
        createExternalAccountExtraArgs: action.extraArguments
      }
    case constants.CREATE_EXTERNAL_ACCOUNT_ERROR:
      return {
        ...state,
        createExternalAccountRetrieving: false,
        createExternalAccountError: action.body || true,
        createExternalAccountResponse: null,
        createExternalAccountExtraArgs: action.extraArguments,
        createExternalAccountErrorStatus: action.response.status
      }
    case constants.CANCEL_ORDER_BY_ID_PENDING:
      return {
        ...state,
        cancelOrderRetrieving: true,
        cancelOrderError: null,
        cancelOrderResponse: null
      }
    case constants.CANCEL_ORDER_BY_ID_FULFILLED:
      return {
        ...state,
        cancelOrderRetrieving: false,
        cancelOrderError: null,
        cancelOrderResponse: 'OK'
      }
    case constants.CANCEL_ORDER_BY_ID_ERROR:
      return {
        ...state,
        cancelOrderRetrieving: false,
        cancelOrderError: action.body || true,
        cancelOrderResponse: null
      }
    case constants.APPROVE_ORDER_BY_ID_PENDING:
      return {
        ...state,
        approveOrderRetrieving: true,
        approveOrderError: null,
        approveOrderResponse: null
      }
    case constants.APPROVE_ORDER_BY_ID_FULFILLED:
      return {
        ...state,
        approveOrderRetrieving: false,
        approveOrderError: null,
        approveOrderResponse: 'OK'
      }
    case constants.APPROVE_ORDER_BY_ID_ERROR:
      return {
        ...state,
        approveOrderRetrieving: false,
        approveOrderError: action.body || true,
        approveOrderResponse: null
      }
    case constants.SYNCHRONIZE_CARDS_PENDING:
      return {
        ...state,
        synchronizeCardsRetrieving: true,
        synchronizeCardsError: null,
        synchronizeCardsResponse: null
      }
    case constants.SYNCHRONIZE_CARDS_FULFILLED:
      return {
        ...state,
        synchronizeCardsRetrieving: false,
        synchronizeCardsError: null,
        synchronizeCardsResponse: 'OK'
      }
    case constants.SYNCHRONIZE_CARDS_ERROR:
      return {
        ...state,
        synchronizeCardsRetrieving: false,
        synchronizeCardsError: action.body || true,
        synchronizeCardsResponse: null
      }
    case constants.GET_FREE_EMAIL_AVAILABLE_ERROR:
      return {
        ...state,
        getFreeEmailAvailableRetrieving: false,
        getFreeEmailAvailableError: action.body || true,
        getFreeEmailAvailableResponse: {
          available: false,
          count: 'failed to load'
        }
      }
    case constants.RESET_FILTER_COMMENTS_RESPONSE:
      return {
        ...state,
        filterCommentsResponse: null
      }
    case constants.GET_LOGOUT_FULFILLED:
      return {
        ...state,
        getLogoutResponse: action.body || true
      }
    case constants.RESET_ADD_SERVICE_RESPONSE:
      return {
        ...state,
        addServiceResponse: null
      }
    case constants.UPDATE_NAMESERVERS_FOR_DOMAIN_FULFILLED:
      return {
        ...state,
        updateNameServersSuccess: true,
        updateNameServersPending: false
      }
    case constants.UPDATE_NAMESERVERS_FOR_DOMAIN_PENDING:
      return {
        ...state,
        updateNameServersPending: true,
        updateNameServersSuccess: false,
        updateNameServersError: null
      }
    case constants.UPDATE_NAMESERVERS_FOR_DOMAIN_ERROR:
      return {
        ...state,
        updateNameServersError: action.body,
        updateNameServersPending: false
      }
    case constants.CANCEL_MULTIPLE_SERVICES_PENDING:
      return {
        ...state,
        cancelMultipleServicesRetrieving: true,
        cancelMultipleServicesResponse: null,
        cancelMultipleServicesError: null,
        cancelledServices: null
      }
    case constants.CANCEL_MULTIPLE_SERVICES_FULFILLED:
      return {
        ...state,
        cancelMultipleServicesRetrieving: false,
        cancelMultipleServicesSuccess: true,
        cancelMultipleServicesResponse: true,
        cancelledServices: action.extraArguments
      }
    case constants.CANCEL_SERVICE_PENDING:
      return {
        ...state,
        cancelServiceRetrieving: true,
        cancelServiceResponse: null,
        cancelServiceError: null
      }
    case constants.CANCEL_SERVICE_FULFILLED:
      return {
        ...state,
        cancelServiceRetrieving: false,
        cancelServiceResponse: true,
        cancelServiceSuccess: true
      }
    case constants.RESET_TEST_TOOL:
      return {
        ...state,
        getAccountByIdResponse: null,
        getSitesTestToolResponse: null,
        createNewAccountTestToolResponse: null,
        getAccountTestToolResponse: null,
        createNewSiteTestToolResponse: null,
        generateTokenTestToolResponse: null
      }
    case constants.RESET_TEST_TOOL_ERROR:
      return {
        ...state,
        getAccountByIdError: null,
        getAccountTestToolError: null,
        createNewAccountTestToolError: null,
        getSitesTestToolError: null,
        createNewSiteTestToolError: null,
        generateTokenTestToolError: null
      }
    case constants.RESTORE_ACCOUNT_FULFILLED:
      return {
        ...state,
        restoreAccountResponse: true,
        restoreAccountRetrieving: false,
        restoreAccountError: null
      }
    case constants.POST_REFUND_SERVICES_PENDING:
      return {
        ...state,
        postRefundServicesResponse: null,
        postRefundServicesRetrieving: true,
        postRefundServicesError: null
      }
    case constants.POST_REFUND_SERVICES_ERROR:
      return {
        ...state,
        postRefundServicesError: true,
        postRefundServicesRetrieving: false
      }
    case constants.POST_REFUND_SERVICES_FULFILLED:
      return {
        ...state,
        postRefundServicesSuccess: true,
        postRefundServicesRetrieving: false,
        postRefundServicesError: false
      }
  }

  if (listenState) {
    return listenState
  }
}

export default reducer
